<template>
  <div class="menu-container">
    <SubMenu
      :nav-list="navList"
      :opened-menus="openedMenus"
      :default-path="path"
      @select="onSelect"
      @clickSubMenu="onClickSubMenu"
    />
  </div>
</template>
<script>
import SubMenu from './sub-menu.vue';

export default {
  name: 'Menu',
  components: {
    SubMenu,
  },
  props: {
    navList: {
      default() {
        return [];
      },
      type: Array
    },
    defaultPath: {
      type: String,
      default: ''
    },
    openedDepth: {
      type: Number,
      default: 0,
    },
    expandedAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openedMenus: [],
      orignOpendMenus: [],
      path: this.defaultPath,
    };
  },
  watch: {
    expandedAll(newValue) {
      if (newValue) {
        this.orignOpendMenus = this.openedMenus;
        this.openedMenus = this.handleOpenedMenus(this.navList, 4);
      } else {
        this.openedMenus = this.orignOpendMenus;
      }
    },
  },
  mounted() {
    this.openedMenus = this.findPathWithParents(this.navList, this.path);
    this.orignOpendMenus = this.openedMenus;
  },
  methods: {
    isExternalLink(link) {
      if (typeof link !== 'string') {
        return false;
      }
      if (link.indexOf('https') === 0 || link.indexOf('http') === 0) {
        return true;
      }
      return false;
    },
    onSelect(path) {
      if (!this.isExternalLink(path) && this.$router) {
        this.$router.push(path);
      }
      this.$emit('select', path);
    },
    onClickSubMenu(path) {
      if (this.openedMenus.includes(path)) {
        const index = this.openedMenus.indexOf(path);
        this.openedMenus.splice(index, 1);
      } else {
        this.openedMenus.push(path);
      }
    },
    handleOpenedMenus(menuList, depth = 2, openedList = []) {
      if (!Array.isArray(menuList) || depth === 0) return;
      depth -= 1;
      menuList.filter(item => !!item).forEach(menu => {
        const { isGroupTitle, subNavList, path } = menu;
        if (!isGroupTitle && subNavList.length > 0) {
          openedList.push(path);
          this.handleOpenedMenus(subNavList, depth, openedList);
        }
      });

      return openedList;
    },
    findPathWithParents(navList, targetPath, parentPaths = []) {
      for (const item of navList) {
        // 检查当前项的 path 是否匹配
        if (item.path === targetPath) {
          // 找到匹配项，返回当前路径和父路径
          return [...parentPaths, item.path];
        }

        // 如果有子项，递归查找
        if (item.subNavList && item.subNavList.length > 0) {
          const result = this.findPathWithParents(item.subNavList, targetPath, [...parentPaths, item.path]);
          if (result) {
            return result; // 如果找到，返回结果
          }
        }
      }
      return null; // 如果没有找到，返回 null
    }
  }
};
</script>
<style lang="less" scoped>

</style>
